import { render, staticRenderFns } from "./VabBoxAreaTopPanel.vue?vue&type=template&id=030c1ef3"
import script from "./VabBoxAreaTopPanel.vue?vue&type=script&lang=js"
export * from "./VabBoxAreaTopPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030c1ef3')) {
      api.createRecord('030c1ef3', component.options)
    } else {
      api.reload('030c1ef3', component.options)
    }
    module.hot.accept("./VabBoxAreaTopPanel.vue?vue&type=template&id=030c1ef3", function () {
      api.rerender('030c1ef3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabBoxArea/components/VabBoxAreaTopPanel.vue"
export default component.exports